export { default } from '@shikijs/themes/catppuccin-latte'
